import { LoadingIndicator } from '@components';
import React from 'react';
import NotificationDetail from '../NotificationDetail';

const DetailPanel = ({ isLoadingMsg, selectedNotification }) => {
  if (isLoadingMsg) {
    return (
      <div className="mensageria-detail-loading">
        <LoadingIndicator />
      </div>
    );
  }

  if (selectedNotification) {
    return <NotificationDetail selectedNotification={selectedNotification} />;
  }

  return (
    <div className="mensageria-detail-empty">
      <p>Clique em uma notificação para ver os detalhes.</p>
    </div>
  );
};

export default DetailPanel;
